import { create } from 'zustand';
import { coinApi } from '../services/user/coin.api';
import { ICoinAccount } from '@packages/global';

interface CoinState {
  account: ICoinAccount | null;
  isLoading: boolean;
  loadAccount: () => Promise<void>;
  updateBalance: (balance: number) => void;
  clear: () => void;
}

export const useCoinStore = create<CoinState>()((set, get) => ({
  account: null,
  isLoading: false,

  loadAccount: async () => {
    set({ isLoading: true });
    try {
      const account = await coinApi.getAccount();
      set({ account, isLoading: false });
    } catch (error) {
      console.error('加载剧点账户失败:', error);
      set({ isLoading: false });
    }
  },

  updateBalance: (balance: number) => {
    set((state) => ({
      account: state.account ? { ...state.account, balance } : null,
    }));
  },

  clear: () => {
    set({ account: null, isLoading: false });
  },
}));
